import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClienteSituacaoModule } from '../cliente-situacao.module';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteSituacaoMultiselectComponent } from './cliente-situacao-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteSituacaoModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClienteSituacaoMultiselectComponent
    ],
    exports: [
        ClienteSituacaoMultiselectComponent
    ]
})
export class ClienteSituacaoMultiselectModule { }
